import React, { Component } from 'react';

import {
    Button,
    Modal,
    Form,
    FormGroup,
    ControlLabel,
    FormControl
} from 'react-bootstrap';

class CreateSwagger extends Component {
  constructor(props) {
    super(props);

    this.state = {
      groupId: "",
      name: "",
      content: ""
    }
  }

  groupsOptions = () => {
    return this.props.groups.map(group => {
      return (
          <option key={group.id} value={group.id}>
              {group.name}
          </option>
      );
    })
  }

  onChangeName = (event) => {
    this.setState({ name: event.target.value });
  }

  onChangeGroup = (event) => {
    this.setState({ groupId: event.target.value });
  }

  onChangeContent = (event) => {
    this.setState({ content: event.target.value });
  }

  save = () => {
    this.props.hide();
    this.props.onSave(this.state);
  }

  render() {
    return (
      <Modal show={this.props.show} onHide={this.props.hide}>
        <Modal.Header closeButton>
          <Modal.Title>New Swagger</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <FormGroup>
              <ControlLabel>Group</ControlLabel>
                <FormControl componentClass="select" placeholder="select" onChange={this.onChangeGroup}>
                  <option value="">Choose a group</option>
                  {this.groupsOptions()}
                </FormControl>
              </FormGroup>
              <FormGroup>
                <ControlLabel>Name</ControlLabel>
                <FormControl onChange={this.onChangeName} />
              </FormGroup>
              <FormGroup>
                <ControlLabel>Content</ControlLabel>
                <FormControl onChange={this.onChangeContent} componentClass="textarea" />
              </FormGroup>
            </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.save}>Save</Button>
          <Button onClick={this.props.hide}>Close</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default CreateSwagger;



// WEBPACK FOOTER //
// ./src/components/swagger-view/modals/CreateSwagger.js